import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellContext } from '@tanstack/react-table';

import { WebEDIRowData } from 'support/types/webediTable';

import { CellProps } from '../../types';
import { DropdownCell } from './DropdownCell';

export type Props = CellContext<WebEDIRowData, unknown> & CellProps;

export const BooleanCell = (props: Props) => {
  const { t } = useTranslation();
  const booleanCellOptions = useMemo(
    () => [
      { label: t('common:yes'), value: true },
      { label: t('common:no'), value: false },
    ],
    [t],
  );
  return <DropdownCell {...props} options={booleanCellOptions} />;
};
